import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import remove from 'lodash/remove';
import find from 'lodash/find';
import includes from 'lodash/includes';
import Table from '../Table';
import Menu from '../Menu';
import './MiniTable.css';

class MiniTable extends React.Component {
  constructor(props) {
    super(props);
    let index = 0;
    const hasSome = props.columns.some((col, i) => {
      if (col.accessor === props.leftColumn || props.leftColumn === '') {
        index = i;
        return true;
      }
      return false;
    });

    const options = this.getMenuOptions(index);
    this.state = {
      leftColumnIndex: hasSome ? index : 0,
      columnsFiltered: this.getTableColumns(index + 1, index),
      menuOptions: options,
      selectedMenuOption: options[0].name,
      sortColumn: this.getDefaultSort(index),
      sortDirection: props.sortDirection || 'ascending',
    };
    this.selectedOption = this.selectedOption.bind(this);
    this.getTableColumns = this.getTableColumns.bind(this);
    this.getMenuOptions = this.getMenuOptions.bind(this);
    this.getDefaultSort = this.getDefaultSort.bind(this);
  }

  componentWillReceiveProps(newProps) {
    let index = 0;
    const hasSome = this.props.columns.some((col, i) => {
      if (col.accessor === newProps.leftColumn || newProps.leftColumn === '') {
        index = i;
        return true;
      }
      return false;
    });
    if (hasSome && index !== this.state.leftColumnIndex) {
      const options = this.getMenuOptions(index);
      const newState = {
        leftColumnIndex: index,
        columnsFiltered: this.getTableColumns(0, index),
        menuOptions: options,
      };

      if (!includes(options, this.state.selectedMenuOption)) {
        newState.selectedMenuOption = options[0].name;
      }
      this.setState(newState);
    }

    if (newProps.sortColumn !== this.state.sortColumn) {
      this.setState({ sortColumn: newProps.sortColumn });
    }

    if (newProps.sortDirection !== this.state.sortDirection) {
      this.setState({ sortDirection: newProps.sortDirection });
    }
  }

  getDefaultSort(index) {
    const accessorsArr = this.getTableColumns(index + 1, index);
    if (this.props.sortColumn) {
      const hasDefault = accessorsArr.some((col) => {
        if (col.accessor === this.props.sortColumn || this.props.sortColumn === '') {
          return true;
        }
        return false;
      });
      if (!hasDefault) {
        return accessorsArr[0].accessor;
      }
    }
    return this.props.sortColumn;
  }

  getTableColumns(row, defaultIndex) {
    const { columns } = this.props;
    let column = {};
    if (this.state) {
      if (this.state.leftColumnIndex !== defaultIndex) {
        const index = defaultIndex === 0 ? 1 : 0;
        column = { ...columns[index] };
      } else {
        column = find(columns, { Header: this.state.menuOptions[row].name });
      }
    } else if (columns[defaultIndex + 1]) {
      column = { ...columns[defaultIndex + 1] };
    }

    const newColumns = [
      { ...columns[defaultIndex] },
      { ...column },
    ];
    return newColumns;
  }

  getMenuOptions(fixedIndex) {
    const { columns } = this.props;
    let newColumns = [...columns];
    newColumns = remove(newColumns, (header) => {
      return (header.accessor !== newColumns[fixedIndex].accessor);
    });
    const menuOpt = newColumns.map((option, index) => {
      return (
        {
          id: index,
          name: option.Header ? option.Header : '',
        }
      );
    });
    return menuOpt;
  }

  selectedOption(row) {
    const newColumns = this.getTableColumns(row, this.state.leftColumnIndex);
    this.setState({
      columnsFiltered: newColumns,
      selectedMenuOption: this.state.menuOptions[row].name,
    });
    if (this.props.onColumnChange) {
      this.props.onColumnChange(this.state.menuOptions[row]);
    }
  }

  static defaultProps = {
    id: '',
    className: '',
    leftColumn: '',
    styling: [],
    text: 'View: ',
    sortColumn: null,
    sortDirection: 'asc',
    autosort: true,
  };

  render() {
    const {
      id,
      className,
      data,
      columns,
      styling,
      text,
      autosort,
      onColumnChange,
      ...otherProps
    } = this.props;
    const {
      columnsFiltered,
      menuOptions,
      selectedMenuOption,
      sortColumn,
      sortDirection,
    } = this.state;
    const classes = classNames(
      'ng-ui-widgets',
      'ng-ui-mini-table',
      className,
    );
    return (
      <div className={classes}>
        <Menu
          id={`${id}-menu`}
          options={menuOptions}
          selectedLabel={selectedMenuOption}
          onChange={this.selectedOption}
          hasLabel
          label={text}
          boxed
        />
        <Table
          data={data}
          columns={columnsFiltered}
          styling={styling}
          sortColumn={sortColumn || columnsFiltered[0].accessor}
          sortDirection={sortDirection}
          autosort={autosort}
          {...otherProps}
        />
      </div>
    );
  }
}

MiniTable.propTypes = {
  id: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  styling: PropTypes.array,
  leftColumn: PropTypes.string,
  text: PropTypes.string,
  sortColumn: PropTypes.string,
  sortDirection: PropTypes.oneOf(['ascending', 'descending', 'asc', 'desc']),
  autosort: PropTypes.bool,
  onColumnChange: PropTypes.func,
};

export default MiniTable;